// ES lang
export default {
    username: "Nombre de usuario",
    password: 'Contraseña',
    repeat_password: 'Repetir contraseña',
    email: 'Correo electrónico',
    infoUser:'Información del usuario',
    userPermissions:'Permisos de usuario',
    stressSymptoms:"Síntomas de estrés",
    socioDemographic:"Socio demográfico",
    name: 'Nombre',
    first_name: 'Nombres',
    last_name: 'Apellido',
    institute: 'Institución',
    download: 'Descargar',
    position: 'Cargo',
    loading: 'Cargando',
    login: 'Iniciar sesión',
    copyright: 'Todos los derechos reservados',
    optional: 'Opcional',
    description: 'Descripción',
    delete: 'Eliminar',
    deletePermit:'Eliminar permiso',
    successDelete:'Eliminado correctamente',
    submit: 'Enviar',
    update: 'Actualizar',
    create: 'Crear',
    save: 'Guardar',
    home:'Inicio',
    new_evaluator:'Nuevo evaluador',
    newPermit:'Nuevo permiso',
    permit:'Permiso',
    create_evaluator:'Crear evaluador',
    update_evaluator:'Actualizar evaluador',
    evaluator:'Evaluadores',
    accept:'Aceptar',
    cancel: 'Cancelar',
    icon: 'Ícono',
    order: 'Orden',
    subject: 'Asunto',
    successSave:'Guardado correctamente',
    body: 'Cuerpo',
    code: 'Código',
    codebars: 'Código de barras',
    reference_manufactures: 'Referencia de fábrica',
    document_type: 'Tipo de documento',
    document_number: 'Número de documento',
    thirdparty: 'Tercero',
    temperature: 'Temperatura',
    expiration_date: 'Fecha de vencimiento',
    lote: 'Lote',
    locations: 'Ubicaciones',
    location: 'Ubicación',
    city: 'Ciudad',
    selectEvaluator:'Seleccionar evaluador',
    fiscal_responsabilities: 'Responsabilidades fiscales',
    emails: 'Correos',
    sendMailPdf: 'Enviar al correo electrónico',
    account_number: 'Número de cuenta',
    identification_type: 'Tipo de identificación',
    full_name: 'Nombre completo',
    brand: 'Nombre comercial',
    identification: 'Identificación',
    address: 'Dirección',
    typist:'Digitador',
    number_of_employees: 'Número de empleados',
    evaluator_name: 'Nombre del evaluador',
    evaluator_last_name: 'Apellido del evaluador',
    document: 'Documento',
    profession: 'Profesión',
    professional_card: 'No. de tarjeta profesional',
    ocupational_health_card: 'No. Licencia en salud ocupacional',
    principal_report:'Informe principal',
    grade: 'Postgrado',
    groupUpdatedSuccess:'Grupo actualizado correctamente',
    groupCreatedSuccess:'Grupo creado correctamente',
    assessment_type: 'Tipo de prueba',
    date: 'Fecha',
    general_reports:'Informe de resultados generales',
    card_expedition_date: 'Fecha de expedición de licencia de salud ocupacional',
    report_date: 'Fecha de reporte',
    area_type: 'Pertenece a',
    area: 'Área',
    position_depends_on: 'Cargo superior',
    company: 'Empresa',
    assessment: 'Prueba',
    identification_number: 'Número de identificación (ID)',
    employees_name: 'Nombre del trabajador',
    department_or_sector: 'Departamento o sector',
    application_date: 'Fecha de aplicación del cuestionario',
    age: 'Edad',
    gender: 'Sexo',
    role: 'Rol',
    analyst: 'Analista',
    evaluator: 'Evaluador',
    forms: {
        correct_form_errors: 'Errores'
    },
    validation: {
        alpha: "El campo {_field_} solo debe contener letras",
        alpha_dash: "El campo {_field_} solo debe contener letras, números y guiones",
        alpha_num: "El campo {_field_} solo debe contener letras y números",
        alpha_spaces: "El campo {_field_} solo debe contener letras y espacios",
        between: "El campo {_field_} debe estar entre {min} y {max}",
        confirmed: "El campo {_field_} no coincide",
        digits: "El campo {_field_} debe ser numérico y contener exactamente {length} dígitos",
        double: "El campo {_field_} debe ser numérico o decimal con signo (.)",
        dimensions: "El campo {_field_} debe ser de {width} píxeles por {height} píxeles",
        email: "El campo {_field_} debe ser un correo electrónico válido",
        excluded: "El campo {_field_} debe ser un valor válido",
        ext: "El campo {_field_} debe ser un archivo válido",
        image: "El campo {_field_} debe ser una imagen",
        integer: "El campo {_field_} debe ser un entero",
        length: "El largo del campo {_field_} debe ser {length}",
        max: "El campo {_field_} no debe ser mayor a {length} caracteres",
        max_value: "El campo {_field_} debe de ser {max} o menor",
        mimes: "El campo {_field_} debe ser un tipo de archivo válido",
        min: "El campo {_field_} debe tener al menos {length} caracteres",
        min_value: "El campo {_field_} debe ser {min} o superior",
        numeric: "El campo {_field_} debe contener solo caracteres numéricos",
        oneOf: "El campo {_field_} debe ser un valor válido",
        regex: "El formato del campo {_field_} no es válido",
        required: "El campo {_field_} es obligatorio",
        required_if: "El campo {_field_} es obligatorio",
        size: "El campo {_field_} debe ser menor a {size}KB",
        sameAsPassword: "Las contraseñas deben ser idénticas",
        minLength: "El campo {_field_} debe ser {min} o superior",
    },
    expired_session: 'Tu sesión ha expirado, inicia sesión nuevamente',
    login_required: 'Sesión finalizada',
    login_section: {
        init_msg: "Ingresa nombre de usuario y contraseña para acceder al sitio.",
        forgot_your_password: "¿Olvidaste tu contraseña?",
        dont_have_an_account: "¿No tienes una cuenta?",
        sign_up: "Regístrate"
    },
    company_info_section: {
        company_name: 'Nombre de la compañía',
        phone_number: 'Número de teléfono',
        address: 'Dirección',
        TIN: 'NIT',
        primary_color: 'Color primario',
        whatsapp_number: 'Whatsapp',
        contact_email: 'Email de contacto',
        support_email: 'Email de soporte',
        instagram_name: 'Nombre usuario Instagram',
        instagram_url: 'URL Instagram',
        facebook_name: 'Nombre Facebook',
        facebook_url: 'URL Facebook',
        site_url_back: 'URL sitio (back)',
        site_url_front: 'URL sitio (front)',
        max_packs_oncharge: 'Máximo de paquetes al hombro',
        max_units_per_pack: 'Máximo de unidades por paquete'
    },
    projects: {
        page_title: 'Proyectos',
        name: {
            name: 'Nombre proyecto'
        },
        comments: {
            name: 'Comentarios'
        }
    }
}